import {
  Box,
  Button,
  Divider,
  Grid2,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Logo from '../assets/logo_white.PNG';
import { theme } from '../utils/theme/Theme';
import Iconify from './Iconify';

function Footer() {
  const { i18n } = useTranslation();
  const isArabic = i18n?.language === 'ar';

  const navigate = useNavigate();

  const xs = useMediaQuery('(min-width:700px)');
  const sm = useMediaQuery('(min-width:900px)');
  const lg = useMediaQuery('(min-width:1400px)');

  return (
    <Box
      dir={isArabic ? 'rtl' : 'ltr'}
      backgroundColor={theme.colors.primary}
      paddingX={lg ? 30 : sm ? 20 : 4}
      paddingTop={6}
      paddingBottom={1}
    >
      <Grid2 container columnSpacing={4} rowSpacing={4}>
        <Grid2 size={{ md: 12, lg: 6 }}>
          <Box
            component={'img'}
            src={Logo}
            alt='Logo'
            width={'50%'}
            onClick={() => navigate('/')}
            sx={{ cursor: 'pointer' }}
          />
        </Grid2>
        <Grid2 size={{ md: 12, lg: 6 }} width={'100%'}>
          <Typography
            sx={{
              color: 'white',
              paddingY: 2,
              fontSize: 18,
              maxWidth: sm ? '80%' : '100%',
            }}
          >
            {t(
              'WePlan Wedding & Event Services brings over 15 years of expertise in planning high-profile weddings, corporate events, and special celebrations. Our experienced team ensures seamless execution, handling design, logistics, and vendor coordination with precision. We pride ourselves on delivering exceptional events at competitive prices, making unforgettable experiences accessible without compromising quality.'
            )}
          </Typography>
          <Box display={'flex'}>
            <Box
              display={'flex'}
              alignItems={'center'}
              backgroundColor={theme.colors.secondary}
              padding={1.5}
              borderRadius={1}
              marginInlineEnd={1}
              onClick={() =>
                window.open(
                  'https://www.facebook.com/profile.php?id=61565389160055&_rdc=1&_rdr#',
                  '_blank'
                )
              }
              sx={{ cursor: 'pointer' }}
            >
              <Iconify icon={'uil:facebook'} sx={{ fontSize: 20 }} />
            </Box>
            <Box
              display={'flex'}
              alignItems={'center'}
              backgroundColor={theme.colors.secondary}
              padding={1.5}
              borderRadius={1}
              onClick={() =>
                window.open('https://www.instagram.com/we_plan1', '_blank')
              }
              sx={{ cursor: 'pointer' }}
            >
              <Iconify icon={'simple-icons:instagram'} sx={{ fontSize: 20 }} />
            </Box>
          </Box>
        </Grid2>
      </Grid2>
      <Divider sx={{ borderColor: 'white', marginTop: 4, marginBottom: 0 }} />

      <Box
        display={'flex'}
        flexDirection={xs ? 'row' : 'column'}
        justifyContent={xs ? 'space-between' : 'center'}
        alignItems={'center'}
        marginTop={!xs && 2}
      >
        <Typography
          sx={{
            color: 'white',
            fontSize: 16,
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          {t(
            'Copyright © WePlan Wedding & Event Services all rights reserved.'
          )}
        </Typography>

        <Box>
          <Button
            disableRipple
            onClick={() => navigate('/')}
            sx={{
              padding: 2,
              fontSize: 16,
              color: 'white',
              '&:hover': { backgroundColor: 'transparent', color: 'white' },
            }}
          >
            {t('Home')}
          </Button>
          <Button
            disableRipple
            onClick={() => navigate('/About')}
            sx={{
              padding: 2,
              fontSize: 16,
              color: 'white',
              '&:hover': { backgroundColor: 'transparent', color: 'white' },
            }}
          >
            {t('About')}
          </Button>
          <Button
            disableRipple
            onClick={() => navigate('/ContactUs')}
            sx={{
              padding: 2,
              fontSize: 16,
              color: 'white',
              '&:hover': { backgroundColor: 'transparent', color: 'white' },
            }}
          >
            {t('Contact')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Footer;
